<template>
    <div :class="classes"
         v-html="require('!!html-loader!@oa-svgs/' + filePath + name +'.svg')">
    </div>
</template>

<script>
export default {
  name: 'SvgLoader',
  props: {
    name: {
      type: String,
      required: true,
    },
    colorClass: {
      type: String,
      required: false,
      default: '',
    },
    height: {
      required: false,
      type: Number,
    },
    width: {
      required: false,
      type: Number,
    },
    type: {
      require: false,
      type: String,
      default: 'icon',
      validator: prop => [
        'icon',
        'logo',
      ].includes(prop),
    },
  },
  data() {
    return {
      classes: '',
    };
  },
  computed: {
    filePath() {
      switch (this.type) {
        case 'logo':
          return 'logos/';
        default:
          return 'icons/';
      }
    },
  },
  mounted() {
    if (this.type === 'icon' || (this.type === 'logo' && this.colorClass !== '')) {
      // Add color classes and inherit logic
      this.classes = `${this.colorClass} ut-fill-current`;
    }

    if (this.height) {
      // Set size of SVG
      this.$el.querySelector('svg').setAttribute('height', `${this.height}px`);
    }

    if (this.width) {
      // Set size of icon
      this.$el.querySelector('svg').setAttribute('width', `${this.width}px`);

      if (!this.height) {
        this.$el.querySelector('svg').setAttribute('height', `${this.width}px`);
      }
    }

    // Update all <polygon> with new classes
    for (let i = 0; i < this.$el.querySelectorAll('polygon').length; i += 1) {
      const element = this.$el.querySelectorAll('polygon')[i];
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        element.setAttribute('class', this.classes);
      }
    }

    // Update all <g> with new classes
    for (let i = 0; i < this.$el.querySelectorAll('g').length; i += 1) {
      const element = this.$el.querySelectorAll('g')[i];
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        element.setAttribute('class', this.classes);
      }
    }

    // Update all <path> with new classes
    for (let i = 0; i < this.$el.querySelectorAll('path').length; i += 1) {
      const element = this.$el.querySelectorAll('path')[i];
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        element.setAttribute('class', this.classes);
      }
    }


    // // Update all <ellipse> with new classes
    for (let i = 0; i < this.$el.querySelectorAll('ellipse').length; i += 1) {
      const element = this.$el.querySelectorAll('ellipse')[i];
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        element.setAttribute('class', this.classes);
      }
    }

    // // Update all <rect> with new classes
    for (let i = 0; i < this.$el.querySelectorAll('rect').length; i += 1) {
      const element = this.$el.querySelectorAll('rect')[i];
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        element.setAttribute('class', this.classes);
      }
    }

    // // Update all <circle> with new classes
    for (let i = 0; i < this.$el.querySelectorAll('circle').length; i += 1) {
      const element = this.$el.querySelectorAll('circle')[i];
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        element.setAttribute('class', this.classes);
      }
    }

    // // Update all <polyline> with new classes
    for (let i = 0; i < this.$el.querySelectorAll('polyline').length; i += 1) {
      const element = this.$el.querySelectorAll('polyline')[i];
      if (element.attributes.fill && element.attributes.fill.value !== 'none') {
        element.setAttribute('class', this.classes);
      }
    }
  },
  methods: {},
};
</script>
<style scoped lang="scss">
</style>
